import { useEffect, useState } from "react";
/**
 * A custom hook to trigger validation on demand.
 * @param {Object} options - The options object.
 * @param {boolean} options.trigger - A boolean flag indicating whether to trigger validation.
 * @param {Function} options.validate - A function to perform validation.
 * @returns {Object} - An object containing the state of whether validation has been triggered.
 * @property {boolean} hasTriggered - A boolean indicating whether validation has been triggered.
 */
const useForceValidate = ({ trigger, validate }) => {
  const [hasTriggered, setHasTriggered] = useState(false);

  useEffect(() => {
    if (trigger) {
      setHasTriggered(true);
      validate();
    }
  }, [trigger]);

  return { hasTriggered };
};

export default useForceValidate;
